import FadeInComponent from '../ui/FadeInComponent';
import styles from './About.module.css';
import { IoIosHeart } from 'react-icons/io';

function About() {
    return (
        <section
            id="about"
            className={`container-fluid d-flex flex-column pt-4 ${styles.about}`}
        >
            <FadeInComponent className="row text-center my-heading">
                <h2>About Us</h2>
                <p>
                    Good foods get better when the chef seasons them with{' '}
                    <span className="fancy-squiggle">passion</span> and{' '}
                    <span className="fancy-squiggle">care</span>
                </p>
            </FadeInComponent>

            <FadeInComponent className={`row flex-grow-1 mt-2 ${styles.content}`}>
                <div className="col-12 col-md-6 d-flex flex-column gap-3">
                    <div className={styles.introSection}>
                        <div className={`p-3 rounded-4 ${styles.introCard}`}>
                            <h4 className="text-center">For more than 10 years</h4>

                            <p>
                                We believe that good food is never just about the ingredients.
                            </p>

                            <p>
                                We’re here to create not just delicious meals, but memorable
                                dining experiences where everyone feels welcome and every bite is
                                made with heart{' '}
                                <IoIosHeart
                                    aria-hidden="true"
                                    className={styles.heartIcon}
                                />
                            </p>
                        </div>
                    </div>

                    <div className="p-4">
                        <img
                            className={`rounded-4 ${styles.interiorImage}`}
                            src="/images/background/restaurant-interior.webp"
                            loading="lazy"
                            alt="Restaurant interior full of guests and server"
                        />
                    </div>
                </div>

                <div className="col-12 col-md-6 d-flex flex-column align-items-center justify-content-center text-white">
                    <div className="px-4 h-100 w-100">
                        <img
                            className={`w-100 h-100 rounded-5 p-1 ${styles.coverImage}`}
                            src="/images/background/chef-bg-1.webp"
                            loading="lazy"
                            alt="Chef preparing food"
                        />
                    </div>

                    <div className="p-4 h-100 w-100">
                        <img
                            className={`w-100 h-100 rounded-5 p-3 ${styles.serverImage}`}
                            src="/images/background/server-serving-1.webp"
                            loading="lazy"
                            alt="Server serving food"
                        />
                    </div>
                </div>
            </FadeInComponent>
        </section>
    );
}

export default About;